/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncEntityProcessPage = lazyLoad(
  () => import('./index'),
  module => module.SyncEntityProcessPage
);
